import { Label as Cmpt} from "@/components/ui/label";

function Label({htmlFor, ...props }) {
	return <Cmpt 
				htmlFor={htmlFor}
				{...props}
		   />;
}

export default Label;